<script>
  import { Line } from 'vue-chartjs'
  import chartRendererMixin from '@/components/elements/charts/chartRendererMixin'

  export default {
    extends: Line,
    mixins: [chartRendererMixin]
  }
</script>



// WEBPACK FOOTER //
// LineChart.vue?bb43013a